<app-desktop-properties *ngIf="!isMobile.value" [isNearby]="isNearby" [searchData]="searchData" [highlightsProperties]="highlightsProperties"
  [properties]="desktopProperties" [filters]="filters" [checkedCharacteristics]="checkedCharacteristics"
  [total]="totalProperties"></app-desktop-properties>

<app-mobile-properties *ngIf="isMobile.value" [networkStatus]="networkStatus" [filters]="filters"
  [searchData]="searchData" [properties]="mobileProperties" [total]="totalProperties" [mapProperties]="mapProperties"
  [checkedCharacteristics]="checkedCharacteristics"></app-mobile-properties>
